import { render } from "./BaseDescription.vue?vue&type=template&id=3bcbbeb4"
import script from "./BaseDescription.vue?vue&type=script&lang=js"
export * from "./BaseDescription.vue?vue&type=script&lang=js"

import "./BaseDescription.vue?vue&type=style&index=0&id=3bcbbeb4&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__